import { ZuiDivider } from '@zeiss/zui-react'

export const Divider = ({ children, ...props }) => {
    return <ZuiDivider {...props}>{children}</ZuiDivider>
}
